import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { haySesionAbierta } from './sesion';
import { esApp } from './plataforma';

/**
 * Al abrir la app con la sesión aún viva, al panel.
 *
 * `/` pinta siempre el login y la app arranca siempre en `/`: sin esto, cada apertura enseñaba el
 * login aunque la sesión de 7 días siguiera viva (visto en el simulador el 15-oct-2026). Con Face ID
 * activado, el bloqueo pide la cara encima del panel.
 *
 * Solo en `/`: si la app se abre en otra pantalla (un enlace), esa manda. En la web no hace nada:
 * qué se ve en `/` con sesión es otra decisión.
 */
const AbrirConSesion: React.FC = () => {
	const { pathname } = useLocation();

	if (!esApp() || pathname !== '/' || !haySesionAbierta()) {
		return null;
	}

	return <Navigate to="/dashboard/home" replace />;
};

export default AbrirConSesion;
